import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import SinglePatientInfo from '../../Components/Global_Components/common/SinglePatientInfo';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import SelectField from '../../Components/Global_Components/form/SelectField';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {handleNill, renderDynamicTable, renderReportfield} from '../../utils/templateUtils';
import './oitiChart.scss';

export default function OITIChart(props) {
  const [showTables, setShowTables] = useState({
    medicationFemale: true,
    medicationMale: true
  });
  const [formData, setFormData] = useState({});
  const [tubalPatencyOther, setTubalPatencyOther] = useState(false);
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);

  const [medicationFemaleRows, setMedicationFemaleRows] = useState([
    {
      sno: '1',
      drug: 'Stimucor',
      genericName: 'Letrozole',
      dosage: '5 mg',
      freq: '0-0-1',
      route: 'Oral',
      timing: 'Night',
      duration: '5 days'
    },
    {
      sno: '2',
      drug: 'Letroz',
      genericName: 'Letrozole',
      dosage: '2.5 mg',
      freq: '0-0-2',
      route: 'Oral',
      timing: 'Night',
      duration: '5 days'
    },
    {
      sno: '3',
      drug: 'Folvista / Cor 3 / MecobMB',
      genericName: 'Folic acid + B12 + B6',
      dosage: '1 tab',
      freq: '0-0-1',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days'
    },
    {
      sno: '4',
      drug: 'Ecospirin',
      genericName: 'Aspirin (Low dose)',
      dosage: '75 mg',
      freq: '0-1-0',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days'
    },
    {
      sno: '5',
      drug: 'Puregraf / Humog',
      genericName: 'HMG (Human Menopausal Gonadotropin)',
      dosage: '75 / 150 IU',
      freq: 'As advised',
      route: 'SC',
      timing: '—',
      duration: 'As advised'
    },
    {
      sno: '6',
      drug: 'Follisurge',
      genericName: 'Recombinant FSH',
      dosage: '75 / 150 IU',
      freq: 'As advised',
      route: 'SC',
      timing: '—',
      duration: 'As advised'
    },
    {
      sno: '7',
      drug: 'Glycomet SR',
      genericName: 'Metformin',
      dosage: '500 mg',
      freq: '1-0-1',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days'
    },
    {
      sno: '8',
      drug: 'Myo D3 / Cystop',
      genericName: 'Myo-Inositol + D-Chiro + Vit D3',
      dosage: '1 sachet',
      freq: 'OD',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days'
    },
    {
      sno: '9',
      drug: 'Ovares / Ovaflo',
      genericName: 'DHEA (Dehydroepiandrosterone)',
      dosage: '—',
      freq: '1-1-1',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days'
    },
    {
      sno: '10',
      drug: 'Omega 3',
      genericName: 'Omega-3 fatty acids',
      dosage: '—',
      freq: '0-0-1',
      route: 'Oral',
      timing: 'Night (with meal)',
      duration: '30 days'
    },
    {
      sno: '11',
      drug: 'CoQ',
      genericName: 'Coenzyme Q10',
      dosage: '—',
      freq: '1-0-0',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days'
    },
    {
      sno: '12',
      drug: 'T.C Vit / Celin',
      genericName: 'Vitamin C',
      dosage: '500 mg',
      freq: '1-0-1',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days'
    },
    {
      sno: '13',
      drug: 'T.Neuroplex / Neurobion',
      genericName: 'Vitamin B-complex',
      dosage: '1 tab',
      freq: 'OD',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days'
    }
  ]);

  const medicationFemaleHeaders = [
    {key: 'sno', label: 'S. No'},
    {key: 'drug', label: 'Medication (Brand Name)'},
    {key: 'genericName', label: 'Generic Name'},
    {key: 'dosage', label: 'Dose'},
    {key: 'freq', label: 'Frequency'},
    {key: 'route', label: 'Route'},
    {key: 'timing', label: 'Timing'},
    {key: 'duration', label: 'Days'}
  ];

  const [medicationMaleRows, setMedicationMaleRows] = useState([
    {
      sno: '1',
      drug: 'T. Infuse M / Ultra Q 300/Ferpill Max',
      genericName: 'Coenzyme Q10 + Zinc + Lycopene + Selenium',
      dosage: '1 tab',
      freq: '0-0-1',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days'
    },
    {
      sno: '2',
      drug: 'C. Etamin',
      genericName: 'Vitamin E',
      dosage: '400 mg',
      freq: '1-0-1',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days'
    },
    {
      sno: '3',
      drug: 'T.Vit C',
      genericName: 'Vitamin C',
      dosage: '1 gm',
      freq: '1-0-1',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days'
    },
    {
      sno: '4',
      drug: 'T. Neuroplex / Neurobion',
      genericName: 'Vitamin B-complex',
      dosage: '1 tab',
      freq: 'OD',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days'
    }
  ]);

  const medicationMaleHeaders = [
    {key: 'sno', label: 'S. No'},
    {key: 'drug', label: 'Medication (Brand Name)'},
    {key: 'genericName', label: 'Generic Name'},
    {key: 'dosage', label: 'Dose'},
    {key: 'freq', label: 'Frequency'},
    {key: 'route', label: 'Route'},
    {key: 'timing', label: 'Timing'},
    {key: 'duration', label: 'Days'}
  ];


  const handleChange = e => {
    const {name, value} = e.target;
    setFormData(prev => ({...prev, [name]: value}));
  };

  const handlesubmit = () => {
    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('iuiChartReportWrap').innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'OI TIC'
            }
          };

          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  return (
    <div id='IUIChartTemplate'>
      <div className='IUIChartTemplate'>
        <div style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img className='header_image' src={headerimage} style={{width: '100%', margin: '0 auto'}}></img>
          </div>
          <h2 style={{display: 'flex', justifyContent: 'center'}}>OI + TIC</h2>

          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />
        </div>
        <div className='detail'>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='LMP:' name='lmp' value={formData.lmp} required={false} onChange={handleChange} inputClassName='show' type='date' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Plan:' name='plan' value={formData.plan} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Cycle No:' name='cycleNo' value={formData.cycleNo} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <SelectField
                label='Type of Subfertility'
                name='subfertility'
                value={formData.subfertility}
                options={[
                  {label: 'Primary', value: 'Primary'},
                  {label: 'Secondary', value: 'Secondary'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Married for:' name='marriedFor' value={formData.marriedFor} required={false} onChange={handleChange} inputClassName='show' endLabel='years' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Trying for:' name='tryingFor' value={formData.tryingFor} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>
          <h4>Baseline Investigations</h4>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Day 2/3 Scan:' startLabel='Uterus' name='uterus' value={formData.uterus} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='ET:' name='et' value={formData.et} required={false} onChange={handleChange} inputClassName='show' endLabel='MM' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='RT Ovary AFC:' name='rtOvaryAFC' value={formData.rtOvaryAFC} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='LT Ovary AFC:' name='ltOvaryAFC' value={formData.ltOvaryAFC} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='AMH:' name='amh' value={formData.amh} required={false} onChange={handleChange} inputClassName='show' endLabel='ng/mL' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='TSH:' name='tsh' value={formData.tsh} required={false} onChange={handleChange} inputClassName='show' endLabel='μIU/mL' />
            </div>
          </div>
          <div className='row pb-3'>
            <div className='col-md-4'>
              <SelectField
                label='Tubal Patency'
                name='tubalPatency'
                value={formData.tubalPatency}
                options={[
                  {label: 'B/L Patent', value: 'B/L Patent'},
                  {label: 'B/L block', value: 'B/L block'},
                  {label: 'Left Block', value: 'Left Block'},
                  {label: 'Right block', value: 'Right block'},
                  {label: 'Others', value: 'Others'}
                ]}
                onChange={e => {
                  handleChange(e);
                  setTubalPatencyOther(e.target.value === 'Others');
                }}
                placeholder='Please select'
              />
            </div>
            {tubalPatencyOther && (
              <div className='col-md-4'>
                <ReportFormInputWithLabel
                  label='Tubal Patency Description:'
                  name='tubalPatencyDescription'
                  value={formData.tubalPatencyDescription}
                  required={false}
                  onChange={handleChange}
                  inputClassName='show'
                />
              </div>
            )}
            <div className='col-md-4'>
              <SelectField
                label='Semen Analysis'
                name='semenAnalysis'
                value={formData.semenAnalysis}
                options={[
                  {label: 'Normal', value: 'Normal'},
                  {label: 'Oat', value: 'Oat'},
                  {label: 'Soat', value: 'Soat'},
                  {label: 'Asthenospermia', value: 'Asthenospermia'},
                  {label: 'Teratospermia', value: 'Teratospermia'},
                  {label: 'Azoospermia', value: 'Azoospermia'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>

          {showTables.medicationFemale && (
            <TemplateTable
              id='medicationFemale'
              title='💊 Medications – Female Partner'
              headers={medicationFemaleHeaders}
              rows={medicationFemaleRows}
              onRowsChange={(id, newRows) => setMedicationFemaleRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('medicationFemale', setShowTables)}
            />
          )}

          {showTables.medicationMale && (
            <TemplateTable
              id='medicationMale'
              title='💊 Medications – Male Partner'
              headers={medicationMaleHeaders}
              rows={medicationMaleRows}
              onRowsChange={(id, newRows) => setMedicationMaleRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('medicationMale', setShowTables)}
            />
          )}


          <div className='d-flex align-items-start py-2'>
            <label htmlFor='advice' className='fw-bold' style={{width: '180px'}}>
              ADVICE:
            </label>
            <textarea className='Textarea' placeholder='ADVICE' id='advice' name='advice' onChange={handleChange} rows='3' cols='100'></textarea>
          </div>
        </div>

        <p className='pt-3' style={{fontWeight: '600'}}>
          NEXT Appointment - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
        </p>
        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
      <div id='iuiChartReport'>
        <div id='iuiChartReportWrap'>
          <Headers />
          <p className='Dani'></p>
          <div className='patient' style={{border: '1px solid black', borderRadius: '10px', marginBottom: '5px'}}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '5px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '5px'}}>
            <h4 style={{fontWeight: 600, color: '#333', marginBottom: '15px'}}>OI + TIC</h4>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('LMP:', formData.lmp?.split('-').reverse().join('-'))}
            {renderReportfield('Plan:', formData.plan)}
            {renderReportfield('Cycle No:', formData.cycleNo)}
            {renderReportfield('Type of Subfertility:', formData.subfertility)}
            {renderReportfield('Married for:', `${formData.marriedFor || ''} years`)}
            {renderReportfield('Trying for:', formData.tryingFor)}
          </div>
          <div style={{fontWeight: 'bold'}}>Baseline Investigations</div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Day 2/3 Scan: Uterus:', formData.uterus)}
            {renderReportfield('ET:', `${formData.et || ''} MM`)}
            {renderReportfield('RT Ovary AFC:', formData.rtOvaryAFC)}
            {renderReportfield('LT Ovary AFC:', formData.ltOvaryAFC)}
            {renderReportfield('AMH:', `${formData.amh || ''} ng/mL`)}
            {renderReportfield('TSH:', `${formData.tsh || ''} μIU/mL`)}
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Tubal Patency:', formData.tubalPatency)}
            {formData.tubalPatency === 'Others' && renderReportfield('Tubal Patency Description:', formData.tubalPatencyDescription)}
            {renderReportfield('Semen Analysis:', formData.semenAnalysis)}
          </div>

          {showTables.medicationFemale &&
            renderDynamicTable(
              '💊 Medications – Female Partner',
              ['S. No', 'Medication (Brand Name)', 'Generic Name', 'Dose', 'Frequency', 'Route', 'Timing', 'Days'],
              ['sno', 'drug', 'genericName', 'dosage', 'freq', 'route', 'timing', 'duration'],
              medicationFemaleRows
            )}

          {showTables.medicationMale &&
            renderDynamicTable(
              '💊 Medications – Male Partner',
              ['S. No', 'Medication (Brand Name)', 'Generic Name', 'Dose', 'Frequency', 'Route', 'Timing', 'Days'],
              ['sno', 'drug', 'genericName', 'dosage', 'freq', 'route', 'timing', 'duration'],
              medicationMaleRows
            )}


          <div style={{marginBottom: '5px'}}>
            <div style={{fontWeight: '600', margin: '0 10px 10px 10px'}}>ADVICE:</div>
            <pre style={{margin: '0 10px 10px 10px', fontFamily: 'inherit', whiteSpace: 'pre-wrap'}}>{formData.advice}</pre>
          </div>
          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '5px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          </div>
          <p className='Dani'></p>

          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
